import { ACCProject } from '../ACCProject';

export class FrontendACCProject extends ACCProject
{

}
